<template>
  <div class="carkit-container">
    <el-row>
      <el-form :inline="true"
               :model="formInline">
        <el-form-item label="公司名称"
                      size="small">
          <el-input v-model="formInline.user"
                    placeholder="请输入公司名称"></el-input>
        </el-form-item>

        <el-button type="primary"
                   class="searchBtn"
                   @click="onSubmit">查询</el-button>

      </el-form>
    </el-row>
    <div class="carkit_table">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="50"
                         fixed>
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         prop="companyName"
                         label="物流公司名称"
                         min-width="100"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         label="智能硬件安装数量"
                         min-width="100"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.value}}台</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { carkit } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      formInline: {
        user: ''
      },
      data: []
    }
  },
  mounted () {
    this.getCarkit()
  },
  methods: {
    getCarkit () {
      carkit().then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
        }
      })
    },
    onSubmit () {
      carkit({ companyName: this.formInline.user }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
        }
      })
    },
    handleCurrentChange (val) { // 分页
      let pageNum = val
      carkit({ pageNum }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.carkit-container
  height 100%
  .searchBtn
    searchBtn()
    margin-top 6px
  .carkit_table
    height calc(100% - 126px)
    .el-table
      background #f7f9fb
      th
        background #e7f0f8
        .cell
          height 25px
          line-height 25px
      td
        .cell
          height 40px
          line-height 40px
          size12()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
